/** Crossref relations namespace (`relations.xsd`). */
export const RELATIONS_NS = 'http://www.crossref.org/relations.xsd';
